import * as variables from './variables.js';
import * as $ from 'jquery';
declare global {
	interface Window { jQuery: JQueryStatic; }
}

import './lib/AnimationEasing';
import "./component/Analytics";

import DetectBrowser from './lib/DetectBrowser';
DetectBrowser.addStyleClasses(document.documentElement);
const browserInfo = DetectBrowser.getInfo();

import ViewportTracker from './lib/ViewportTracker';
ViewportTracker.init(variables);

import { MainMenu, CollapseExpandChildrenListener } from './component/MainMenu/MainMenu';
const animationUnsupported = browserInfo.android && browserInfo.android.browserVersion === 4.0;
const mainMenu = new MainMenu({
	menu: '#menu',
	menuTriggers: '.menuTrigger--open, .menuTrigger--close, .pageOverlay',
	nodeTrigger: '.node--hasChild > a',
	styleClass: {
		menuOpen: 'hasMenuOpen',
		nodeOpen: 'isOpen'
	},
	listeners: [
		new CollapseExpandChildrenListener(animationUnsupported ? 0 : 400, 'easeOutExpo')
	]
});

// Polyfills object-fit
// @ts-ignore
// var objectFitImages = require('object-fit-images');
// if (!objectFitImages.supportsObjectFit) {
// 	objectFitImages();
// }

import Scrolled from './component/Scrolled';
new Scrolled({
    scrolledClass: 'hasScrolled',
    scrolledDistanceClass: 'hasScrolledDistance',
    scrollDistanceDown: '.pageHeader',
    scrollDistanceUp: 20
});

import Forms from './component/Forms';
Forms.init();

import SearchForm from './component/HeaderSearchForm';
new SearchForm('.headerSearchForm', '.headerSearchForm__icon', '.headerSearchForm__query', 'open');

import accountAccess from './component/AccountAccess';
new accountAccess();

import StickyHeader from './component/StickyHeader';
new StickyHeader();

import CollapsableGroup from './component/CollapsableGroup';
new CollapsableGroup();

import Gateway from './component/Gateway';
new Gateway();

import AutoCompleter from "./component/AutoCompleter";
AutoCompleter();

import slickCarousel from './component/SlickCarousel';
slickCarousel();

import SiteAnimations from './component/SiteAnimations';
new SiteAnimations([
	{
		observedSelector: '.featuredContent, .richContent',
		options: {
			rootMargin: '-50px 0px',
			threshold: 0
		}
	},
	{
		observedSelector: '.featuredCardListing, .featuredArticles, .listItemGroup, .childListing',
		options: {
			rootMargin: '-50px 0px',
			threshold: 0
		}
	}
]);
